import { render, staticRenderFns } from "./InvitationModal.vue?vue&type=template&id=18b4b8ef&"
import script from "./InvitationModal.vue?vue&type=script&lang=js&"
export * from "./InvitationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports